import {
    TileLayout,
    TileLayoutRepositionEvent, Drawer, DrawerContent, DrawerItem, PanelBar, PanelBarItem
} from "@progress/kendo-react-layout";
import { useSelector } from "react-redux";
import { getSidebarStatusSelector } from "../Slices/SidebarSlice";
import { getMenuStatusSelector } from "../Slices/MenuSlice";
import {
    updateDashboard,
    getDashboardExportSelector,
    getDashboardResetSelector, getDashboardPositionDataSelector,
} from "../Slices/DashboardSlice";
import { PDFExport } from "@progress/kendo-react-pdf";
import React, { Fragment, useState, useEffect, PropsWithChildren } from "react";
import { useAppDispatch } from "../../Core/store.hooks";
interface DashboardProps {
    positionData: any;
    sidebarItems: any;
}
interface SidebarItmeProps {
    item: any;
    title: string;
    expanded: boolean;
}
const MyCom = () => <div>Hello I am some text</div>;

const sidebarData = [
    { title: 'Calendar', item: <MyCom />, expanded: true },
    { title: 'Attachments', item: <MyCom />, expanded: true },
    { title: 'Favourites', item: <MyCom />, expanded: true }
];
const SidebarItem = (props: any) => {
    return (
        <DrawerItem>
            <PanelBar >
                {props.items.map((item, idx) => (
                    <PanelBarItem key={idx} expanded={item.expanded} title={item.title}>
                    {item.item}
                </PanelBarItem>))}
            </PanelBar>
        </DrawerItem>
    );
};

const Dashboard = (propsArgs: PropsWithChildren<DashboardProps>) => {

    const pdfExportComponent = React.useRef<PDFExport>(null);
    const exportCounter = useSelector(getDashboardExportSelector);
    const resetCounter = useSelector(getDashboardResetSelector);
    const _sidebarOpen = useSelector(getSidebarStatusSelector);
    const savedPositionData = useSelector(getDashboardPositionDataSelector);
    const _menuOpen = useSelector(getMenuStatusSelector);
    const dispatch = useAppDispatch();

    const args = {
        ...propsArgs,
    };
    const [children, updateChildrentt] = useState<any>(null);
    const [removedIDs, updateRemovedIds] = useState<string[]>([]);
    const [fullScreenID, updateFullScreenID] = useState<string | null>(null);
    const [positionData, setPositionData] = React.useState<Array<any>>([]);
    const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
    const [drawerExpanded, setDrawerExpanded] = React.useState(true);
    const [firstLoad, updateFirstLoad] = useState(true);


    useEffect(() => {
        if (args.children != null) updateChildrentt(args.children);
       
    }, [args.children]);
    useEffect(() => {
       
        dispatch<any>(
            updateDashboard({
                resetCounter: resetCounter,
                exportCounter: exportCounter ,
                positionData: args.positionData,
            })
        );
    }, []);
    useEffect(() => {
        
        if (firstLoad) {
            setPositionData(propsArgs.positionData);
            updateFirstLoad(false)
        } else {
            setPositionData(savedPositionData);
        }
    }, [savedPositionData]);

    useEffect(() => {
        if (resetCounter > 0) {
            updateFullScreenID(null);
            setIsFullScreen(false);
            updateDashboard({
                resetCounter: resetCounter,
                exportCounter: exportCounter,
                positionData: args.positionData,
            });
            updateRemovedIds([]);
        }
    }, [resetCounter]);
    useEffect(() => {
        if (exportCounter > 0) exportPDFWithComponent();
    }, [exportCounter]);
  
    const makeFullScreen = (id: string) => {
        fullScreenID != null
            ? updateFullScreenID(null)
            : updateFullScreenID(id);
    };
    function fullscreenHandler(setToFull: boolean, id: string) {
        setIsFullScreen(setToFull);
        updateFullScreenID(id);
        if (!setToFull) updateFullScreenID(null);
    }
    function closeHandler(id: string) {
        updateFullScreenID(null);
        setIsFullScreen(false);
        const noneRemovedIDs: string[] = [];
        const newPositionData: any = [];
        for (let k = 0; k < children.length; k++) {
            if (removedIDs.indexOf(children[k].props.id) < 0) {
                noneRemovedIDs.push(children[k].props.id);
            }
        }
        for (let i = 0; i < noneRemovedIDs.length; i++) {
            if (noneRemovedIDs[i] == id) {
                for (let j = 0; j < positionData.length; j++) {
                    if (j != i) newPositionData.push(positionData[j]);
                }
                break;
            }
        }
        updateRemovedIds([...removedIDs, id]);
        dispatch<any>(
            updateDashboard({
                resetCounter: resetCounter,
                exportCounter: exportCounter,
                positionData: newPositionData,
            })
        );
      /*  setPositionData(newPositionData);*/
    }
    function renderChildren() {
        if (args.children == null) {
            return null;
        } else {
            const childrenWithProps:any = React.Children.map(
                children,
                (child: any) => {
                    if (
                        React.isValidElement(child as React.ReactElement<any>)
                    ) {
                        if (removedIDs.indexOf(child.props.id) < 0) {
                            if (fullScreenID != null) {
                                if (child.props.id == fullScreenID) {
                                    return React.cloneElement(
                                        child as React.ReactElement<any>,
                                        {
                                            makeFullScreen,
                                        },
                                    );
                                }
                            } else {
                                return React.cloneElement(
                                    child as React.ReactElement<any>,
                                    {
                                        makeFullScreen,
                                    }
                                );
                            }
                        }
                    }
                }
            );
            const tiles: any = [];
            let idCounter = 0;
            if (childrenWithProps == null) return tiles;
            childrenWithProps.forEach((element: any) => {
                idCounter++;
                const obj: any = {};
                if (
                    element.props.header != null &&
                    element.props.header != undefined &&
                    element.props.header != ""
                ) {
                    obj.body = element;
                    if (!element.props.static) {
                        obj.header = (
                            <span>
                                {element.props.header}
                                {isFullScreen ? (
                                    <Fragment>
                                        <span
                                            style={{
                                                float: "right",
                                                marginLeft: "5px",
                                            }}
                                            title="Remove component"
                                            onClick={() =>
                                                closeHandler(element.props.id)
                                            }
                                            className="k-icon k-i-close"
                                        ></span>
                                        <span
                                            style={{
                                                float: "right",
                                                fontSize: "13px",
                                                marginTop: "1px",
                                            }}
                                            title="Exit Full screen"
                                            onClick={() =>
                                                fullscreenHandler(
                                                    false,
                                                    element.props.id
                                                )
                                            }
                                            className="k-icon k-i-fullscreen-exit"
                                        ></span>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <span
                                            style={{
                                                float: "right",
                                                marginLeft: "5px",
                                            }}
                                            title="Remove component"
                                            onClick={() =>
                                                closeHandler(element.props.id)
                                            }
                                            className="k-icon k-i-close"
                                        ></span>
                                        <span
                                            style={{
                                                float: "right",
                                                fontSize: "13px",
                                                marginTop: "1px",
                                            }}
                                            title="Full screen"
                                            onClick={() =>
                                                fullscreenHandler(
                                                    true,
                                                    element.props.id
                                                )
                                            }
                                            className="k-icon k-i-fullscreen"
                                        ></span>
                                    </Fragment>
                                )}
                            </span>
                        );
                    } else {
                        obj.header = element.props.header;
                    }
                    obj.hintClassName = "k-header-override";
                } else {
                    obj.item = element;
                }
                obj.id = element.props.id;
                if (!element.props.static) {
                    obj.reorderable = true;
                    obj.resizable = true;
                } else {
                    obj.reorderable = false;
                    obj.resizable = false;
                }
                tiles.push(obj);
            });
            return tiles;
        }
    }
    const handleReposition = (e: TileLayoutRepositionEvent) => {
        
        dispatch<any>(
            updateDashboard({
                resetCounter: resetCounter,
                exportCounter: exportCounter ,
                positionData: e.value,
            })
        );
    };
    const exportPDFWithComponent = () => {
        if (
            pdfExportComponent != null &&
            pdfExportComponent.current &&
            pdfExportComponent.current != null
        ) {
            pdfExportComponent.current.save();
        }
    };
    const getDashboardHeight = () => {
        if (_menuOpen) {
            return "calc(100vh - 142px)";
        }
        return "calc(100vh - 62px)";
    }
    const getRowHeight = () => {
        let areaHeight: number = window.innerHeight;
        if (areaHeight > 1000) areaHeight = 1000;
        if (_menuOpen) {
            return (areaHeight - 210) / 6;
        }
        return (areaHeight - 122) / 6;
    };
    const renderContent = () => {
        if (args.positionData.length == 0) {
            return (
                <div style={{ backgroundColor: "#fff" }}>
                    Loading...
                </div>
            );
        }
        if (args.children == null) return null;
        if (positionData.length == 0) return null;
        return (<div className="pp-dashboard-content" style={{ height: getDashboardHeight() }}>
            <PDFExport
                scale={0.3}

                // @ts-ignore
                ref={pdfExportComponent}
                paperSize="auto"
                margin={40}
                fileName={`Report for ${new Date().getFullYear() +
                    " " +
                    new Date().getMonth() +
                    " " +
                    new Date().getDay()
                    }`}
                author="Fleet Radar App"
            >
                <TileLayout
                    autoFlow="row dense"
                    columns={6}

                    rowHeight={getRowHeight()}
                    positions={
                        isFullScreen
                            ? [{ col: 1, colSpan:6, rowSpan: 6 }]
                            : positionData
                    }
                    gap={{ rows: 10, columns: 10 }}
                    items={renderChildren()}
                    onReposition={handleReposition}
                    dataItemKey={"id"}
                    ignoreDrag={(e) => {
                        return (
                            !e.target.classList.contains("k-card-header") &&
                            !e.target.classList.contains("k-resize-handle")
                        );
                    }}
                />
            </PDFExport></div>)
    }
    if (args.sidebarItems == null) return (<div> {renderContent()}</div>);
    return (
        <div className="pp-dashboard-drawer">
            <Drawer expanded={_sidebarOpen} mode='push' width={220} items={[{ items:args.sidebarItems}]} item={SidebarItem} style={{ backgroundColor:"454347" }}>
                <DrawerContent>
                        
                    {renderContent()}
                </DrawerContent>
            </Drawer>
        </div>
    );
};
export default Dashboard;